import { faker } from '@faker-js/faker'

import { SaleConfiguration } from '../../contracts/appointment/saleConfiguration'
import { asBuilder } from '../asBuilder'

export const getSaleConfiguration = asBuilder<SaleConfiguration>((): SaleConfiguration => {
  return {
    id: faker.string.uuid(),
    hospitalId: faker.number.int(),
    serviceOfferId: faker.number.int(),
    isDisabledByAdmin: faker.datatype.boolean(),
    isAvailableForSale: faker.datatype.boolean(),
    createdAt: faker.date.recent().toISOString(),
    updatedAt: faker.date.recent().toISOString(),
  }
})
